// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lander {
  width: 100%;
  height: 100%;
  background: url('wallpaper.png');
  background-size: cover;
  padding: 30px;
  box-sizing: border-box;
}
.lander ion-app {
  width: 100% !important;
  height: 100% !important;
  padding: 0;
  margin: 0;
  border: none;
}
.lander .cntr {
  width: 100%;
  min-height: 100%;
  background: #fbfaf8;
  border-radius: 12px;
  overflow: hidden;
  /* box-shadow: 0px 5px 10px #838383; */
  border: 2px solid black;
}
.lander .head {
  height: 13vh;
  width: 100%;
  background: #fff2e5;
  padding: 20px 60px;
  box-sizing: border-box;
}
.lander .head .logo_txt {
  margin-left: -5px;
  margin-top: 23px;
  color: #e9b3a3;
}
.lander .head .icon {
  height: 100%;
  width: 90px;
}
.lander .head .icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.lander .bod {
  height: 70vh;
  width: 100%;
  padding: 60px 150px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
}
.lander .bod h1 {
  font-size: 42px;
  color: #d2b094;
}
.lander .bod h3 {
  font-size: 14px;
  color: #c3beb8;
  font-weight: 400;
}
.lander .bod h4 {
  font-size: 10px;
  width: 70%;
  color: #d2d0ce;
}
.lander .bod .app_btn {
  border: none;
  padding: 20px 39px;
  margin-top: 10px;
  margin-bottom: 20px;
  background: none;
  border: 2px solid #aea296;
  color: #aea296;
  border-radius: 4px;
  cursor: pointer;
  text-transform: uppercase;
}
.lander .bod .app_btn:hover {
  background: #aea296;
  color: #fff;
}
.lander .socialBtns {
  display: flex;
  grid-gap: 10px;
  width: 100%;
  margin-top: 30px;
  margin-bottom: 30px;
}
.lander .socialBtns img {
  height: 50px;
  object-fit: cover;
  cursor: pointer;
  border-radius: 6px;
}
.lander .split {
  width: 50%;
  min-width: 480px;
}
.lander .min_text {
  width: 50%;
}
.lander .inline {
  display: inline-flex;
}
.lander .phone {
  margin-top: -151px;
  height: 760px;
  min-width: 385px;
  width: 385px;
  max-width: 385px;
  border: 2px solid black;
  border-radius: 11px;
  overflow: hidden;
  position: absolute;
  right: 10%;
}
.lander .phone img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.lander .phone .ion-page {
  height: 100%;
  width: 385px;
  margin: auto;
}
.lander .foot {
  height: 10vh;
  width: 100%;
  background: #fff2e5;
  padding: 30px 60px;
  box-sizing: border-box;
  display: inline-flex;
  flex-wrap: wrap;
}
.lander .foot h4 {
  font-size: 12px;
  color: #908c8a;
}
.lander .foot ul {
  list-style: none;
  display: inline-flex;
  grid-gap: 10px;
  float: right;
}
.lander .foot ul li {
  font-size: 12px;
  color: #908c8a;
  cursor: pointer;
  text-decoration: underline;
}
@media screen and (max-width: 1140px) {
  .lander .head {
    padding: 20px 20px;
  }
  .lander .bod {
    padding: 20px;
    height: auto;
    flex-direction: column-reverse;
  }
  .lander .split {
    width: 100%;
    min-width: 0px;
  }
  .lander .min_text {
    width: 100%;
  }
  .lander .phone {
    width: 100%;
    height: 100%;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
  }
  .lander .foot {
    height: -moz-fit-content;
    height: fit-content;
    padding: 20px 20px;
  }
  .lander .foot ul {
    padding: 0;
    float: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/landing/landing.page.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,gCAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;AACJ;AACI;EACI,sBAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;AACR;AAEI;EACI,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sCAAA;EACA,uBAAA;AAAR;AAGI;EACI,YAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;AADR;AAGQ;EACI,iBAAA;EACA,gBAAA;EACA,cAAA;AADZ;AAIQ;EACI,YAAA;EACA,WAAA;AAFZ;AAIY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AAFhB;AAOI;EACI,YAAA;EACA,WAAA;EAEA,mBAAA;EACA,sBAAA;EAEA,aAAA;EACA,eAAA;AAPR;AASQ;EACI,eAAA;EACA,cAAA;AAPZ;AASQ;EACI,eAAA;EACA,cAAA;EACA,gBAAA;AAPZ;AASQ;EACI,eAAA;EACA,UAAA;EACA,cAAA;AAPZ;AAUQ;EACI,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AARZ;AAUY;EACI,mBAAA;EACA,WAAA;AARhB;AAaI;EACI,aAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AAXR;AAaQ;EACI,YAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AAXZ;AAeI;EACI,UAAA;EACA,gBAAA;AAbR;AAgBI;EACI,UAAA;AAdR;AAiBI;EACI,oBAAA;AAfR;AAkBI;EACI,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AAhBR;AAkBQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AAhBZ;AAmBQ;EACI,YAAA;EACA,YAAA;EACA,YAAA;AAjBZ;AAqBI;EACI,YAAA;EACA,WAAA;EACA,mBAAA;EAEA,kBAAA;EACA,sBAAA;EACA,oBAAA;EACA,eAAA;AApBR;AAsBQ;EACI,eAAA;EACA,cAAA;AApBZ;AAuBQ;EACI,gBAAA;EACA,oBAAA;EACA,cAAA;EACA,YAAA;AArBZ;AAuBY;EACI,eAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;AArBhB;AA4BI;EACI;IACI,kBAAA;EA1BV;EA6BM;IACI,aAAA;IACA,YAAA;IACA,8BAAA;EA3BV;EA8BM;IACI,WAAA;IACA,cAAA;EA5BV;EA+BM;IACI,WAAA;EA7BV;EAgCM;IACI,WAAA;IACA,YAAA;IACA,gBAAA;IACA,iBAAA;IACA,eAAA;EA9BV;EAiCM;IACI,wBAAA;IAAA,mBAAA;IACA,kBAAA;EA/BV;EAiCU;IACI,UAAA;IACA,WAAA;EA/Bd;AACF","sourcesContent":[".lander {\n    width: 100%;\n    height: 100%;\n    background: url(../../assets/wallpaper.png);\n    background-size: cover;\n    padding: 30px;\n    box-sizing: border-box;\n\n    ion-app {\n        width: 100% !important;\n        height: 100% !important;\n        padding: 0;\n        margin: 0;\n        border: none;\n    }\n\n    .cntr {\n        width: 100%;\n        min-height: 100%;\n        background: #fbfaf8;\n        border-radius: 12px;\n        overflow: hidden;\n        /* box-shadow: 0px 5px 10px #838383; */\n        border: 2px solid black;\n    }\n\n    .head {\n        height: 13vh;\n        width: 100%;\n        background: #fff2e5;\n        padding: 20px 60px;\n        box-sizing: border-box;\n\n        .logo_txt {\n            margin-left: -5px;\n            margin-top: 23px;\n            color: #e9b3a3;\n        }\n\n        .icon {\n            height: 100%;\n            width: 90px;\n\n            img {\n                width: 100%;\n                height: 100%;\n                object-fit: cover;\n            }\n        }\n    }\n\n    .bod {\n        height: 70vh;\n        width: 100%;\n\n        padding: 60px 150px;\n        box-sizing: border-box;\n\n        display: flex;\n        flex-wrap: wrap;\n\n        h1 {\n            font-size: 42px;\n            color: #d2b094;\n        }\n        h3 {\n            font-size: 14px;\n            color: #c3beb8;\n            font-weight: 400;\n        }\n        h4 {\n            font-size: 10px;\n            width: 70%;\n            color: #d2d0ce;\n        }\n\n        .app_btn {\n            border: none;\n            padding: 20px 39px;\n            margin-top: 10px;\n            margin-bottom: 20px;\n            background: none;\n            border: 2px solid #aea296;\n            color: #aea296;\n            border-radius: 4px;\n            cursor: pointer;\n            text-transform: uppercase;\n\n            &:hover {\n                background: #aea296;\n                color: #fff;\n            }\n        }\n    }\n\n    .socialBtns {\n        display: flex;\n        grid-gap: 10px;\n        width: 100%;\n        margin-top: 30px;\n        margin-bottom: 30px;\n\n        img {\n            height: 50px;\n            object-fit: cover;\n            cursor: pointer;\n            border-radius: 6px;\n        }\n    }\n\n    .split {\n        width: 50%;\n        min-width: 480px;\n    }\n\n    .min_text {\n        width: 50%;\n    }\n\n    .inline {\n        display: inline-flex;\n    }\n\n    .phone {\n        margin-top: -151px;\n        height: 760px;\n        min-width: 385px;\n        width: 385px;\n        max-width: 385px;\n        border: 2px solid black;\n        border-radius: 11px;\n        overflow: hidden;\n        position: absolute;\n        right: 10%;\n\n        img {\n            width: 100%;\n            height: 100%;\n            object-fit: cover;\n        }\n\n        .ion-page {\n            height: 100%;\n            width: 385px;\n            margin: auto;\n        }\n    }\n\n    .foot {\n        height: 10vh;\n        width: 100%;\n        background: #fff2e5;\n\n        padding: 30px 60px;\n        box-sizing: border-box;\n        display: inline-flex;\n        flex-wrap: wrap;\n\n        h4 {\n            font-size: 12px;\n            color: #908c8a;\n        }\n\n        ul {\n            list-style: none;\n            display: inline-flex;\n            grid-gap: 10px;\n            float: right;\n\n            li {\n                font-size: 12px;\n                color: #908c8a;\n                cursor: pointer;\n                text-decoration: underline;\n            }\n        }\n    }\n\n    //for mobile devices\n\n    @media screen and (max-width: 1140px) {\n        .head {\n            padding: 20px 20px;\n        }\n\n        .bod {\n            padding: 20px;\n            height: auto;\n            flex-direction: column-reverse;\n        }\n\n        .split {\n            width: 100%;\n            min-width: 0px;\n        }\n\n        .min_text {\n            width: 100%;\n        }\n\n        .phone {\n            width: 100%;\n            height: 100%;\n            margin-left: 0px;\n            margin-right: 0px;\n            margin-top: 0px;\n        }\n\n        .foot {\n            height: fit-content;\n            padding: 20px 20px;\n\n            ul {\n                padding: 0;\n                float: none;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
